import { FC } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Action from '../Action/Action';
import styles from './TargetListItem.module.css';
import cn from 'classnames';
import InputField from '../InputField';
import Button from '../Button';
import { ProjectTargetResponseDto } from '../../../store/landscapeAPI/project/dto/response/project-target-response.dto';

interface TargetListItemProps {
  onDeleteClick: (id: string) => void;
  moveListItem: (from: number, to: number) => void;
  listItem: ProjectTargetResponseDto;
  listItems: ProjectTargetResponseDto[];
  listItemsLength: number;
  listItemIndex: number;
  handleOnChange: (projectTarget: ProjectTargetResponseDto) => void;
}

const TargetListItem: FC<TargetListItemProps> = ({
  onDeleteClick,
  moveListItem,
  listItem,
  listItems,
  listItemsLength,
  listItemIndex,
  handleOnChange,
}) => {
  return (
    <ListGroup.Item as="li" className={cn(styles.listItem)} action>
      <div className={cn(styles.inputField)}>
        <InputField
          label="Title"
          type="text"
          onChange={(e) => handleOnChange({ ...listItem, label: e })}
          value={listItem.label ?? ''}
          id="input-field-label"
        />
      </div>
      <div className={cn(styles.sortActionsWrapper)}>
        {listItemsLength > 1 && listItemIndex !== 0 && (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              moveListItem(
                listItem.sortOrder,
                listItems[listItemIndex - 1].sortOrder
              );
            }}
          >
            ↑
          </Button>
        )}
        {listItemsLength > 1 && listItemIndex !== listItemsLength - 1 && (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              moveListItem(
                listItem.sortOrder,
                listItems[listItemIndex + 1].sortOrder
              );
            }}
          >
            ↓
          </Button>
        )}
      </div>
      <div className={cn(styles.inputField)}>
        <InputField
          label="Value"
          type="text"
          onChange={(e) => handleOnChange({ ...listItem, value: e })}
          value={listItem.value ?? ''}
          id="input-field-value"
        />
      </div>
      <Action
        type="delete"
        size="sm"
        onClick={() => onDeleteClick(listItem.id)}
      />
    </ListGroup.Item>
  );
};

export default TargetListItem;
